document.documentElement.classList.add('js');

function getBody() {
  return document.body;
}

function openMenu() {
  const body = getBody();
  if (body) body.classList.add('menu-open');
}

function closeMenu() {
  const body = getBody();
  if (body) body.classList.remove('menu-open');
}

function openCartDrawer() {
  const body = getBody();
  if (body) body.classList.add('cart-drawer-open');

  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) drawer.setAttribute('aria-hidden', 'false');
}

function closeCartDrawer() {
  const body = getBody();
  if (body) body.classList.remove('cart-drawer-open');

  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) drawer.setAttribute('aria-hidden', 'true');
}

async function getCartState() {
  const response = await fetch('/cart.js', {
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  if (!response.ok) {
    throw new Error('Unable to load cart state');
  }

  return response.json();
}

async function refreshCartCount() {
  const cart = await getCartState();

  document.querySelectorAll('.site-header__cart-button').forEach((button) => {
    button.textContent = cart.item_count > 0 ? `Cart (${cart.item_count})` : 'Cart';
  });

  return cart;
}

async function refreshCartDrawer(openAfter = false) {
  try {
    // Important fix:
    // Always render the drawer section from the homepage route,
    // not from /collections/... or /products/...
    const response = await fetch('/?section_id=cart-drawer&_=' + Date.now(), {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to load drawer markup');
    }

    const markup = await response.text();
    const temp = document.createElement('div');
    temp.innerHTML = markup;

    const incoming = temp.querySelector('[data-cart-drawer]');
    const current = document.querySelector('[data-cart-drawer]');

    if (!incoming || !current) {
      throw new Error('Drawer markup missing');
    }

    current.replaceWith(incoming);

    await refreshCartCount();

    if (openAfter) {
      requestAnimationFrame(() => {
        openCartDrawer();
      });
    }
  } catch (error) {
    console.error('Cart drawer refresh failed:', error);

    // Do not hard redirect anymore.
    // Just try to open whatever drawer exists.
    if (openAfter) openCartDrawer();
  }
}

async function addToCart(form) {
  const formData = new FormData(form);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || 'Add to cart failed');
    }

    await refreshCartDrawer(true);
  } catch (error) {
    console.error('Add to cart failed:', error);
    alert('Could not add this item to cart. Please try again.');
  }
}

async function changeCartLine(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(quantity, 0)
      })
    });

    if (!response.ok) {
      throw new Error('Cart change failed');
    }

    await refreshCartDrawer(true);
  } catch (error) {
    console.error('Unable to update cart line:', error);
  }
}

document.addEventListener('click', function (event) {
  if (event.target.closest('[data-menu-toggle]')) {
    openMenu();
    return;
  }

  if (event.target.closest('[data-menu-close]')) {
    closeMenu();
    return;
  }

  if (
    event.target.closest('[data-menu-overlay]') &&
    event.target === event.target.closest('[data-menu-overlay]')
  ) {
    closeMenu();
    return;
  }

  if (event.target.closest('[data-cart-drawer-open]')) {
    event.preventDefault();
    openCartDrawer();
    return;
  }

  if (event.target.closest('[data-cart-drawer-close]')) {
    event.preventDefault();
    closeCartDrawer();
    return;
  }

  const cartButton = event.target.closest('[data-cart-change]');
  if (cartButton) {
    event.preventDefault();
    const key = cartButton.getAttribute('data-cart-change');
    const quantity = parseInt(cartButton.getAttribute('data-cart-quantity'), 10);
    changeCartLine(key, quantity);
  }
});

document.addEventListener('submit', function (event) {
  const form = event.target.closest('[data-add-to-cart-form]');
  if (!form) return;

  event.preventDefault();
  addToCart(form);
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeMenu();
    closeCartDrawer();
  }
});